var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDpcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(6757.013 3762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 24,
    height: 24,
    transform: "translate(-6757.013 -3762)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(-6754.344 -3759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M14.557,37.515a1.77,1.77,0,0,0-1.284-.589,1.831,1.831,0,0,0-1.3.585l-1.2,1.2c-.1-.053-.2-.1-.293-.152-.137-.068-.266-.133-.376-.2a13.048,13.048,0,0,1-3.127-2.849,7.7,7.7,0,0,1-1.026-1.618c.312-.285.6-.581.881-.866.106-.106.213-.217.319-.323a1.743,1.743,0,0,0,0-2.629L6.116,29.032c-.118-.118-.239-.239-.353-.361-.228-.236-.467-.479-.714-.707a1.8,1.8,0,0,0-1.273-.558,1.861,1.861,0,0,0-1.292.558l-.008.008-1.292,1.3A2.779,2.779,0,0,0,.36,31.042a6.66,6.66,0,0,0,.486,2.819,16.357,16.357,0,0,0,2.906,4.848A17.878,17.878,0,0,0,9.706,43.37a9.275,9.275,0,0,0,3.343.988c.08,0,.163.008.239.008a2.863,2.863,0,0,0,2.192-.942c0-.008.011-.011.015-.019a8.637,8.637,0,0,1,.665-.688c.163-.156.331-.319.494-.49a1.9,1.9,0,0,0,.574-1.314,1.826,1.826,0,0,0-.585-1.3Zm1.36,4s0,0,0,0c-.148.16-.3.3-.463.463a9.989,9.989,0,0,0-.733.76,1.831,1.831,0,0,1-1.428.6c-.057,0-.118,0-.175,0a8.24,8.24,0,0,1-2.963-.889,16.876,16.876,0,0,1-5.607-4.392A15.423,15.423,0,0,1,1.811,33.5a5.424,5.424,0,0,1-.425-2.378A1.744,1.744,0,0,1,1.91,30l1.3-1.3a.864.864,0,0,1,.577-.27.813.813,0,0,1,.555.266l.011.011c.232.217.452.441.684.68.118.122.239.243.361.369l1.037,1.037a.725.725,0,0,1,0,1.178c-.11.11-.217.22-.327.327-.319.327-.623.631-.954.927-.008.008-.015.011-.019.019a.775.775,0,0,0-.2.862l.011.034a8.327,8.327,0,0,0,1.227,2l0,0a13.944,13.944,0,0,0,3.374,3.07,5.187,5.187,0,0,0,.467.255c.137.068.266.133.376.2.015.008.03.019.046.027a.824.824,0,0,0,.376.095.812.812,0,0,0,.577-.262l1.3-1.3a.859.859,0,0,1,.574-.285.774.774,0,0,1,.547.277l.008.008,2.093,2.093A.751.751,0,0,1,15.917,41.516Z",
    transform: "translate(-0.344 -26.365)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M245.366,86.943a4.889,4.889,0,0,1,3.981,3.981.51.51,0,0,0,.505.425.678.678,0,0,0,.087-.008.513.513,0,0,0,.422-.593,5.912,5.912,0,0,0-4.817-4.817.516.516,0,0,0-.593.418A.507.507,0,0,0,245.366,86.943Z",
    transform: "translate(-235.651 -82.661)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M257.3,7.94A9.735,9.735,0,0,0,249.371.008a.512.512,0,1,0-.167,1.011,8.7,8.7,0,0,1,7.089,7.089.51.51,0,0,0,.505.425.679.679,0,0,0,.087-.008A.5.5,0,0,0,257.3,7.94Z",
    transform: "translate(-239.337 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpcPhone);
export default __webpack_public_path__ + "static/media/dpcPhone.44a5170ec5fb1f8f921a2dd25735ec12.svg";
export { ForwardRef as ReactComponent };